/**
 * 특정 티징 상품 대상으로 재구매 알림 비활성화 처리 추가
 */
export const TEASING_PRODUCT_IDS = new Set([
  '158002204',
  '158784639',
  '158991877',
  '158991951',
  '158991991',
  '158992288',
  '158992347',
  '158992352',
  '158992363',
  '158992375',
  '158992437',
  '158992441',
  '158992448',
  '158992451',
  '158992456',
]);
